"use client";

import { AuthProvider as SharedAuthProvider, type User } from "shared";

import { signOut } from "@/lib/firebase/auth";
import { auth } from "@/lib/firebase/clientApp";

export interface AuthProviderProps {
  user: User | null;
  children: React.ReactNode;
}

export const AuthProvider: React.FunctionComponent<AuthProviderProps> = ({
  user: serverUser,
  children,
}) => {
  return (
    <SharedAuthProvider
      user={serverUser}
      auth={auth}
      signOutFunction={signOut}
      enableSessionValidation={true}
      loginPath="/login"
    >
      {children}
    </SharedAuthProvider>
  );
};
